import React, { FC, useState } from "react";
import {
   Button,
   FormControl,
   FormLabel,
   IconButton,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalContent,
   ModalFooter,
   ModalHeader,
   ModalOverlay,
   Stack,
   useDisclosure,
   useToast,
} from "@chakra-ui/react";
import { RiLockPasswordFill } from "react-icons/ri";
import axios from "axios";
import { IUser } from "../../ts/interfaces/user_interface";
import { PasswordField } from "../Login/PasswordField";

interface ChangePasswordProps {
   user: IUser;
}

export const ChangePassword: FC<ChangePasswordProps> = ({ user }) => {
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [newPwd, setNewPwd] = useState("");
   const [confirmPwd, setConfirmPwd] = useState("");

   const [load, setLoad] = useState(false);
   const toast = useToast();

   return (
      <>
         <IconButton
            aria-label={"icon"}
            icon={<RiLockPasswordFill />}
            onClick={() => {
               setNewPwd("");
               setConfirmPwd("");
               setLoad(false);
               onOpen();
            }}
            colorScheme="brand"
         />
         <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Change password</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  <Stack spacing="3">
                     <FormControl>
                        <FormLabel>New password</FormLabel>
                        <PasswordField
                           placeholder={"New password"}
                           value={newPwd}
                           onChange={(e) => setNewPwd(e.target.value)}
                        />
                     </FormControl>
                     <FormControl>
                        <FormLabel>Confirm password</FormLabel>
                        <PasswordField
                           placeholder={"Confirm password"}
                           value={confirmPwd}
                           onChange={(e) => setConfirmPwd(e.target.value)}
                        />
                     </FormControl>
                  </Stack>
               </ModalBody>

               <ModalFooter>
                  <Button
                     colorScheme="brand"
                     mr={3}
                     isDisabled={load}
                     isLoading={load}
                     onClick={() => {
                        setLoad(true);
                        axios
                           .post(`/admin/users/${user.id}/change-password`, {
                              new_password: newPwd,
                           })
                           .then(() => {
                              setLoad(false);
                              toast({
                                 title: `Commit success`,
                                 position: "top",
                                 status: "success",
                                 isClosable: true,
                              });
                           })
                           .catch((error) => {
                              let res = error.response;
                              if (res) {
                                 toast({
                                    title: res.data.message,
                                    status: "error",
                                    position: "top",
                                    isClosable: true,
                                 });
                              }
                           })
                           .finally(() => onClose());
                     }}
                  >
                     Change password
                  </Button>
                  <Button onClick={onClose} isDisabled={load}>
                     Cancel
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>
      </>
   );
};
